import {
  API_ERROR,
  SUB_LOCATIONS,
  SUB_LOCATIONS_LIST_SUCCESSFUL,
  SELECT_CHANGEVALUE,
  INPUT_CHANGEVALUE,
  SUB_LOCATIONS_ADD,
  SUB_LOCATIONS_ADD_SUCCESSFUL,
  SUB_LOCATIONS_ROW_DATA,
  SUB_LOCATIONS_ROW_DATA_SUCCESSFUL,
  SUB_LOCATIONS_DELETE,
  SUB_LOCATIONS_SETROWDATA,
  MODEL_OPEN,
  MODEL_CLOSE,
  SET_PARAMS,
} from "./actionTypes";

export const getSubLocations = (data) => {
  return {
    type: SUB_LOCATIONS,
    payload: { data },
  };
};

export const SublocationListSuccessful = (locations) => {
  return {
    type: SUB_LOCATIONS_LIST_SUCCESSFUL,
    payload: locations,
  };
};
export const SelecteChangeValue = ({ key, label, key2, value }) => {
  return {
    type: SELECT_CHANGEVALUE,
    payload: { key, label, key2, value },
  };
};
export const InputChangeValue = ({ key, value }) => {
  return {
    type: INPUT_CHANGEVALUE,
    payload: { key, value },
  };
};

export const SublocationAdd = (data) => {
  return {
    type: SUB_LOCATIONS_ADD,
    payload: { data },
  };
};

export const locationAddSuccessful = (response) => {
  return {
    type: SUB_LOCATIONS_ADD_SUCCESSFUL,
    payload: response,
  };
};

export const SublocationRowData = (LocId) => {
  return {
    type: SUB_LOCATIONS_ROW_DATA,
    payload: { LocId },
  };
};

export const locationRowDataSuccessful = (response) => {
  return {
    type: SUB_LOCATIONS_ROW_DATA_SUCCESSFUL,
    payload: response,
  };
};

export const SublocationDelete = (locId) => {
  return {
    type: SUB_LOCATIONS_DELETE,
    payload: { locId },
  };
};

export const SetEditData = (data) => {
  return {
    type: SUB_LOCATIONS_SETROWDATA,
    payload: data,
  };
};

export const model_open = () => {
  return {
    type: MODEL_OPEN,
  };
};

export const model_close = () => {
  return {
    type: MODEL_CLOSE,
  };
};
export const SetParams = (params) => {
  return {
    type: SET_PARAMS,
    payload: params,
  };
};
export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};
